var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Table, TableBody, TableRow, TableCell } from '@mui/material';
import { Typography } from './Typography';
import { Fragment } from 'react';
import { getIsMobile } from '../services/utilisateur';
export var Definitions = function (_a) {
    var datas = _a.datas, _b = _a.title, title = _b === void 0 ? null : _b, _c = _a.icon, icon = _c === void 0 ? null : _c, _d = _a.noBorder, noBorder = _d === void 0 ? false : _d, _e = _a.wrap, wrap = _e === void 0 ? false : _e;
    var isMobile = getIsMobile();
    var getRows = function (_a, isLastRow) {
        var label = _a.label, value = _a.value, _b = _a.colSpan, colSpan = _b === void 0 ? 1 : _b;
        if (isLastRow === void 0) { isLastRow = false; }
        var borderClass = noBorder || isLastRow ? 'border-none' : '';
        if (!label) {
            colSpan += 1;
        }
        if (noBorder) {
            borderClass += ' m-none pb-xsmall pt-none';
        }
        return (_jsxs(_Fragment, { children: [label && (_jsx(TableCell, __assign({ colSpan: colSpan, className: "bold ".concat(borderClass, " ").concat(wrap ? 'nowrap' : '') }, { children: label }))), _jsx(TableCell, __assign({ className: borderClass, colSpan: colSpan }, { children: value }))] }));
    };
    var colSpan = 1;
    for (var _i = 0, datas_1 = datas; _i < datas_1.length; _i++) {
        var data = datas_1[_i];
        if (data.array && data.array.length > colSpan) {
            colSpan = data.array.length;
        }
    }
    return (_jsxs(_Fragment, { children: [title && _jsx(Typography, __assign({ startIcon: icon }, { children: title })), _jsx(Table, { children: _jsx(TableBody, { children: datas.map(function (_a, indexData) {
                        var label = _a.label, value = _a.value, _b = _a.valueUnder, valueUnder = _b === void 0 ? false : _b, array = _a.array;
                        var isLastRow = !isMobile && indexData + 1 === datas.length;
                        return (_jsx(Fragment, { children: valueUnder ? (_jsxs(_Fragment, { children: [label && (_jsx(TableRow, { children: _jsx(TableCell, __assign({ colSpan: colSpan * 2, className: "bold border-none pb-none" }, { children: label })) })), _jsx(TableRow, { children: _jsx(TableCell, __assign({ className: isLastRow ? 'border-none' : '', colSpan: colSpan * 2 }, { children: value })) })] })) : isMobile ? (array ? (array.map(function (cell, index) { return (_jsx(TableRow, { children: getRows(cell, isLastRow) }, "".concat(indexData, "-").concat(index))); })) : (_jsx(TableRow, { children: getRows({ label: label, value: value, colSpan: colSpan }, isLastRow) }))) : (_jsx(TableRow, { children: array
                                    ? array.map(function (cell, index) { return (_jsx(Fragment, { children: getRows(cell, isLastRow) }, "".concat(indexData, "-").concat(index))); })
                                    : getRows({ label: label, value: value, colSpan: colSpan }, isLastRow) })) }, indexData));
                    }) }) })] }));
};
//# sourceMappingURL=Definitions.js.map